<template>
  <div class="test_container">
    <div class="tab_wrap">
      <ul class="ul_wrap">
        <li class="commonli">
          <div class="pop" v-if="totalPaperNum"><span>{{totalPaperNum}}</span></div>
          <router-link :to="{ path: '/testCenter' }">
            <div class="img1">
              <img src="../../assets/images/parent-course/test-center.png" alt="" />
            </div>
            <div class="img2">
              <img src="../../assets/images/parent-course/test-center-text.png" alt="" />
            </div>
          </router-link>
        </li>
        <li class="commonli commonli-2 active">
          <router-link :to="{ path: '/growGroup' }">
            <div class="question question2" @click="showPop">
              <img src="../../assets/images/parent-course/question.png" alt="" />
            </div>
            <div class="child">
              <img src="../../assets/images/parent-course/child.png" alt="" />
            </div>
            <div class="img1" style="margin-right: 23px">
              <img src="../../assets/images/parent-course/grow-group.png" alt="" />
            </div>
            <div class="img2">
              <img src="../../assets/images/parent-course/grow-group-test.png" alt="" />
            </div>
          </router-link>
        </li>
        <li class="commonli commonli-3">
          <router-link :to="{ path: '/course' }">
            <div class="question question1">
              <!-- <img src="../../assets/images/parent-course/question.png" alt=""> -->
            </div>
            <div class="img1">
              <img src="../../assets/images/parent-course/active-course.png" alt="" />
            </div>
            <div class="img2">
              <img src="../../assets/images/parent-course/active-course-text.png" alt="" />
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <present-children class="growClub" :showTitle="showTitle" :children="children" :btnTitle="btnTitle" @growthRecord="growthRecord" @select="select($event)" :value="value"></present-children>
    <div class="growClub_happy" @click="goSpace()">
      <img src="../../assets/images/grow-club/happy.png" class="growClub_happy_pic" />
      <div class="growClub_happy_name">
        <p class="growClub_happy_name_top">开心空间</p>
        <p class="growClub_happy_name_bot">Video</p>
      </div>
    </div>
    <div class="growClub_battal" @click="goEmotion()">
      <img src="../../assets/images/grow-club/battal.png" class="growClub_battal_pic" />
      <div class="growClub_battal_name">
        <p class="growClub_battal_name_top">情绪大作战</p>
        <p class="growClub_battal_name_bot">Emotion</p>
      </div>
    </div>
    <modal ref="modalGrow" btnType='1' :sureText='sureText' :showKid='showKid' :showClsoeBtn='false' :closeFnValue='false' @submit="sure">
      <template v-slot:body>
        <div class="popName">
          <p>{{ popText }}</p>
          <input v-if="modalType===2" type="text" v-model="nickName" placeholder="在这里输入你的昵称哦～">
          <div v-if="modalType===3" class="labels">
            <span v-for="( item , index ) in labels" :key="index">
              <span class="label" :class="{'checkEnable':item.checkEnable}" @click="selectLabel(item)">
                {{item.label}}
              </span>
            </span>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
  import { _checkStudentNickName, _setStudentNickName, _setStudentLabel, _queryLabels } from "../../api/game";
  import PresentChildren from "../../components/present-children/index";
  import { verticalScreen } from "../../assets/js/vertical-screen";
  import Modal from "../../components/common/modal.vue";
  import { decryptBy, encryptBy } from '@/assets/js/encryption';
  import { _paperNum } from '../../api/test-center'
  export default {
    components: { Modal, PresentChildren },
    name: "grow-group",
    data() {
      return {
        totalPaperNum: 0,
        children: [],
        value: "",
        btnTitle: "儿童档案",
        showTitle: true,
        nickNameStatus: "", // 昵称填写状态 true填写了 false未填写
        labelStatus: "", // 标签填写状态 true填写了 false未填写
        modalType: 2,//弹框状态
        nickName: '',// 昵称
        showKid: false,//是否展示小人
        id: '',//用户id
        sureText: '确定',//按钮名称
        popText: '',
        labels: [],// 标签
        // 查询儿童家长进行中的问卷数量
        paramsPaperNum: {
          childId: '',
          parentId: '',
          useObject: ''
        },
      };
    },
    watch: {

    },
    created() {
      // 清楚养育课的session part1
      sessionStorage.removeItem('tabChangeMain')
      sessionStorage.removeItem('tabInfoDetail')
      sessionStorage.removeItem('tabValue')
      this.value = localStorage.getItem("childId");
      this.children =
        decryptBy(localStorage.getItem("children")) &&
        JSON.parse(decryptBy(localStorage.getItem("children")));
      // 清楚之前把存储当前点击的信息
      localStorage.removeItem("happyInfo");
      // 二级目录下的信息集合
      localStorage.removeItem("happyInfoTab");
      // 视频页面的信息集合
      localStorage.removeItem("happySpaceVideo");
      this.paramsPaperNum.childId = this.children[0].id
      this.getObject(this.paramsPaperNum.childId)
      let parentsInfof = decryptBy(localStorage.getItem("parentsInfor")) &&
        JSON.parse(decryptBy(localStorage.getItem("parentsInfor")));
      this.paramsPaperNum.parentId = parentsInfof.id
      this.checkStudentNickName();
      this.paperNum(this.paramsPaperNum)
    },
    mounted() {
      verticalScreen();
      this.id = localStorage.getItem("childId");
      if (JSON.parse(localStorage.getItem('isFirstLogin'))) {
        this.modalTypeChange(1);
        this.$refs.modalGrow.openDialog();
        localStorage.setItem("isFirstLogin", JSON.stringify(false));
      }
    },
    methods: {
      // 查询进行中的家长儿童问券数量
      async paperNum(paramsPaperNum) {
        try {
          let res = await _paperNum(paramsPaperNum)
          let { code, data, message } = res
          if (res && code === 200) {
            this.totalPaperNum = data.childTotal + data.parentCount
          } else {
            this.totalPaperNum = 0
            // 数据获取异常
            Toast(message)
          }
        } catch (error) {
          this.totalPaperNum = 0
        }
      },
      growthRecord() {
        this.$router.push('childrenFile');
      },
      // 判断儿童、学生
      getObject(id) {
        let children = JSON.parse(decryptBy(localStorage.getItem("children")));
        let child = children.filter((item) => {
          return item.id == id
        })
        if (child[0].serviceStatus === 1) {
          this.paramsPaperNum.useObject = 2
        } else {
          this.paramsPaperNum.useObject = 1
        }
      },
      select(value) {
        localStorage.setItem("childId", value);
        this.getObject(value)
        this.value = value;
        this.checkStudentNickName();
      },
      goEmotion() {
        this.$router.push("emotion");
      },
      goSpace() {
        this.$router.push("happySpace");
      },
      // 修改弹窗状态
      modalTypeChange(val) {
        this.modalType = val;
        switch (val) {
          case 1:
            this.sureText = '我知道了';
            this.popText = '“成长社团”模块是为了给孩子提供更为轻松活泼的心理健康教育，改变传统的说教方式，以心理绘本故事、益智游戏、放松视频等更易被青少年接受的方式进行，增加其趣味性和吸引力，让青少年学会放松，掌握自我觉察能力。';
            this.showKid = false;
            break;
          case 2:
            this.sureText = '下一步';
            this.popText = '哈喽，大家好，我是你们的好朋友，开心心，很高兴认识你，和你成为好朋友，方便告诉我你的昵称吗？';
            this.showKid = true;
            break;
          case 3:
            this.sureText = '确定';
            this.popText = '我觉得自己是一个很会关心人的小天使，你觉得自己是什么样子的呢？';
            this.showKid = true;
            break;
        }
      },
      // 查询儿童昵称和标签状态
      checkStudentNickName() {
        _checkStudentNickName(this.value).then((res) => {
          if (res && res.code == 200) {
            this.nickNameStatus = res.data.nickNameStatus;
            this.labelStatus = res.data.labelStatus;
            if (!this.nickNameStatus) {
              this.modalTypeChange(1);
              this.$refs.modalGrow.openDialog();
            }
          } else {
            this.$toast(res.message);
          }
        });
      },
      // 获取标签
      invokeList() {
        _queryLabels({
          studentId: this.value,
          type: 7
        }).then((res) => {
          if (res && res.code == 200) {
            for (let i = 0; i < res.data.length; i++) {
              const element = res.data[i];
            }
            this.labels = res.data;
          } else {
            this.$toast(res.message);
          }
        });
      },
      // 展示弹窗
      showPop() {
        this.checkStudentNickName();
        this.modalTypeChange(1);
        this.$refs.modalGrow.openDialog();
      },
      // 选择标签
      selectLabel(item) {
        item.checkEnable = !item.checkEnable;
      },
      // 确定
      sure() {
        switch (this.modalType) {
          case 1:
            if (this.nickNameStatus) {
              this.$refs.modalGrow.closeDialog();
              return false
            }
            this.modalTypeChange(2);
            break;
          case 2:
            if (!this.nickName) {
              this.$toast('请输入昵称');
              return false
            }
            _setStudentNickName({
              id: this.id,
              nickName: this.nickName
            }).then((res) => {
              if (res && res.code == 200) {
                this.invokeList();
                this.modalTypeChange(3);
              } else {
                this.$toast(res.message);
              }
            });
            break;
          case 3:
            _setStudentLabel(this.labels).then((res) => {
              if (res && res.code == 200) {
                this.modalTypeChange(3);
              } else {
                this.$toast(res.message);
              }
            });
            this.$refs.modalGrow.closeDialog();
            break;
        }

      },
    },
  };
</script>

<style lang="scss" scoped>
  $tabCenter: "../../assets/images/parent-course/tab-center.png";
  $tabCommon: "../../assets/images/parent-course/tab-common.png";
  .test_container {
    .tab_wrap {
      margin-top: -120px;
      display: flex;
      justify-content: center;
      .ul_wrap {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        width: calc(100% - 26px);
        height: 86px;
        .commonli {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 95px;
          height: 75px;
          background: url($tabCommon) no-repeat;
          background-size: contain;
          position: relative;
          .pop {
            position: absolute;
            right: 0;
            top: 0;
            width: 25px;
            height: 25px;
            background-color: #ff5656;
            border-radius: 50%;
            transform: translate(10px, -10px);
            display: flex;
            justify-content: center;
            align-items: center;
            span {
              color: #fff;
              font-size: 12px;
            }
          }
          a {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }
          &.active {
            width: 120px;
            height: 86px;
            background: url($tabCenter) no-repeat;
            background-size: cover;
            .img1 {
              width: 75px;
              height: 50px;
              img {
                display: block;
                width: 100%;
              }
            }
            .img2 {
              width: 58px;
              height: 23px;
              img {
                display: block;
                width: 100%;
              }
            }
          }
          .img1 {
            width: 67px;
            height: 46px;
            img {
              display: block;
              width: 100%;
            }
          }
          .img2 {
            width: 58px;
            height: 23px;
            img {
              display: block;
              width: 100%;
            }
          }
          &.commonli-2,
          &.commonli-3 {
            position: relative;
            .question {
              position: absolute;
              top: 6px;
              width: 20px;
              height: 20px;
              img {
                display: block;
                width: 100%;
              }
            }
            .question1 {
              right: 6px;
            }
            .question2 {
              right: 3px;
            }
            .child {
              position: absolute;
              width: 26px;
              height: 18px;
              img {
                width: 100%;
                display: block;
              }
              right: 1%;
              top: 35%;
            }
          }
        }
      }
    }
    .growClub {
      margin-top: 50px;
    }
    .growClub_happy {
      width: 345px;
      height: 130px;
      margin-left: 15px;
      background: url(./../../assets/images/grow-club/happy-bg.png);
      background-size: cover;
      margin-top: 105px;
      display: flex;
      align-items: center;
      .growClub_happy_pic {
        height: 105px;
        width: 105px;
        margin-left: 10px;
      }
      .growClub_happy_name {
        width: 100px;
        text-align: center;
        .growClub_happy_name_top {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #d55514;
          line-height: 25px;
        }
        .growClub_happy_name_bot {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          margin-top: 5px;
        }
      }
    }
  }
  .growClub_battal {
    width: 345px;
    height: 130px;
    margin-left: 15px;
    background: url(./../../assets/images/grow-club/battal-bg.png);
    background-size: cover;
    margin-top: 28px;
    display: flex;
    align-items: center;
    .growClub_battal_pic {
      height: 105px;
      width: 105px;
      margin-left: 10px;
    }
    .growClub_battal_name {
      width: 100px;
      text-align: center;
      .growClub_battal_name_top {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #d55514;
        line-height: 25px;
      }
      .growClub_battal_name_bot {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        margin-top: 5px;
      }
    }
  }
  a.router-link-exact-active.router-link-active {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .popName {
    width: 255px;
    position: relative;
    // overflow-x: scroll;
    p {
      text-align: center;
    }
    input {
      width: 200px;
      height: 30px;
      background: #f3f3f3;
      border-radius: 4px;
      margin: 20px 26px 0;
    }
    .labels::-webkit-scrollbar {
      display: none;
    }
    .labels {
      width: 100%;
      display: flex;
      overflow-x: scroll;
      line-height: 30px;
      .label {
        margin: 30px 5px 10px;
        display: block;
        width: 76px;
        height: 32px;
        border-radius: 15px;
        border: 1px solid #ff8340;
        text-align: center;
        color: #ff8340;
      }
      .checkEnable {
        width: 76px;
        height: 32px;
        background: #ff8340;
        border-radius: 15px;
        color: #fff;
      }
    }
    .popKid {
      width: 56px;
      position: absolute;
    }
  }
  ::v-deep .el-select-dropdown.el-popper {
    left: 11px !important;
  }
  ::v-deep.el-input__prefix,
  .el-input__suffix {
  }
</style>

